import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@common/components/ui/dialog"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { PasswordForm } from "./-components/form/password-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/account/profile/change-password",
)({
  component: ChangePasswordDialog,
})

function ChangePasswordDialog(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () => navigate({ to: "/settings/account/profile" })

  return (
    <Dialog open onOpenChange={(open) => !open && close()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Change password</DialogTitle>
          <DialogDescription>
            Enter your current password, then choose a new one.
          </DialogDescription>
        </DialogHeader>
        <PasswordForm
          onChange={() => {
            showToast("Saved", "Your password has been changed.", "success")
            close()
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
